import Constants from "config/Constants";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import { PageTitle, Page } from "components/Layout";
import GroupsInfoCardAdornment from "./GroupsInfoCardAdornment";
import GroupsContent from "./GroupsContent";
import Button from "components/Button";
import PlusIcon from "components/Icons/PlusIcon";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import SearchTextProvider from "providers/SearchTextProvider";

function PageHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate("/groups/add");
  }, [navigate]);

  return (
    <>
      <PageTitle endAdornment={<GroupsInfoCardAdornment />}>{t(Constants.routes.groups.titleKey)}</PageTitle>
      <Button variant="primary" size="small" startIcon={<PlusIcon />} onClick={onClick} sx={{ width: "auto" }}>
        {t("global.create_new_label")}
      </Button>
    </>
  );
}

function Groups() {
  return (
    <ThemeProvider2024>
      <Page header={<PageHeader />}>
        <SearchTextProvider>
          <GroupsContent />
        </SearchTextProvider>
      </Page>
    </ThemeProvider2024>
  );
}

export default Groups;
